import { Grid } from 'components/Grid';
import { ColourPalette } from './ColourPalette';
import { EditColourPalette } from './EditColourPalette';

export const ColourPaletteComponent = ({ colourPalette, setColourPalette }) => {
    return (
        <Grid numberOfColumns={1}>
            <EditColourPalette colourPalette={colourPalette} setColourPalette={setColourPalette} />
            <ColourPalette colourPalette={colourPalette.result} />
        </Grid>
    );
};
